/**
 * 营运中心--》回单相关
 */

export default {
  backorder_use_large_size: ["84213", "81888"] // 202511042007578273838
}
